import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./large-callout.css";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".element-largecallout").forEach((el) => {
  const chars = el.querySelectorAll(".element-content-wrapped .word em");
  const container = el.querySelector(".element-container");
  let isDisabled = false;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start: () => {
        const siteHeaderHeight = document.querySelector(".site-header").offsetHeight;
        return `top ${siteHeaderHeight}`;
      },
      end: "+=150%",
      anticipatePin: 1,
      pin: true,
      invalidateOnRefresh: true,
      refreshPriority: 1,
      scrub: 0.5,
      markers: false,
      onLeave: function (self) {
        if (!isDisabled && self.progress >= 1) {
          isDisabled = true;
          const currentScroll = self.start;
          const pinSpacer = container.parentElement.classList.contains("pin-spacer") ? container.parentElement : null;

          if (pinSpacer) {
            const spacerHeight = pinSpacer.offsetHeight;
            gsap.set(pinSpacer, { minHeight: spacerHeight });
          }

          gsap.set(container, { position: "relative", top: 0 });
          self.disable(false, true);

          requestAnimationFrame(() => {
            window.scrollTo(0, currentScroll);
            if (pinSpacer) {
              gsap.set(pinSpacer, { clearProps: "all" });
            }
            gsap.set(container, { clearProps: "all" });
            ScrollTrigger.refresh();
          });
        }
      },
    },
  });

  tl.set(
    chars,
    {
      opacity: 1,
      stagger: 0.1,
    },
    0.1,
  );
});
